module.exports = __webpack_public_path__ + "img/ico_email--black.0679fb62.svg";